module.exports = __webpack_public_path__ + "static/media/brand_logo.484491ae.png";